import {ValidateLoginMethod, LoginMethodId} from "platformed-client/types";
import {invalidateQueries, q} from "../state";
import {platformedClient} from ".";

export async function list() {
  return await platformedClient.internalRequest("get", "/region/{region}/api/login_methods", {path: {}});
}

export async function create(body: ValidateLoginMethod) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/login_methods", {path: {}, body});
  await invalidateQueries([q.loginMethods.filter()]);
  return res;
}

export async function delete_(loginMethodId: LoginMethodId) {
  const res = await platformedClient.internalRequest("delete", "/region/{region}/api/login_methods/{login_method_id}", {
    path: {login_method_id: loginMethodId},
  });
  await invalidateQueries([q.loginMethods.filter()]);
  return res;
}

export async function update(loginMethodId: LoginMethodId, body: ValidateLoginMethod) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/login_methods/{login_method_id}", {
    path: {login_method_id: loginMethodId},
    body,
  });
  await invalidateQueries([q.loginMethods.filter()]);
  return res;
}
